import IconTile from '../../Icon/IconTile';

const SquareCoin = () => <IconTile name="money" />;

export { SquareCoin };
